import { Brand, createBranded } from '@deltasierra/type-utilities';
import { FullAuditable, HasId } from '../../../common';
import { PrintProviderId } from '../../../printProvider';

export type StripeAuthRequestId = Brand<number, 'StripeAuthRequestId'>;
export const StripeAuthRequestId = createBranded<StripeAuthRequestId>();

export interface StripeAuthRequest extends HasId, FullAuditable {
    uuid: string;
    printProviderId: PrintProviderId | null;
}
